'use client';

import Link from '@/components/Link';
import {COMPANY_LEGAL, CONTACT_PHONE, WHATSAPP_LINK} from '@/lib/landing/constants';
import {footerContent} from '@/lib/landing/content';
import {FadeIn, SectionContainer} from './shared';

export function Footer() {
  return (
    <footer id="contacto" className="bg-kobra-navy text-kobra-text-muted-light py-12 border-t border-kobra-border-dark">
      <SectionContainer>
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <FadeIn className="col-span-1 md:col-span-2">
            <Link href="/" className="inline-block mb-4">
              <span className="relative block h-12 w-44 overflow-hidden sm:h-14 sm:w-52">
                <img
                  src="/image/logoBlanco.png"
                  alt="Kobra"
                  className="absolute left-0 top-1/2 h-[240%] w-auto max-w-none -translate-y-1/2"
                />
              </span>
            </Link>
            <p className="max-w-sm mb-4 leading-relaxed text-sm">{footerContent.tagline}</p>
            <p className="text-sm">
              Kobra es una solución tecnológica desarrollada y operada por{' '}
              <span className="text-white font-medium">{COMPANY_LEGAL}</span>
            </p>
          </FadeIn>

          <FadeIn delay={0.1}>
            <div>
              <h3 className="text-white font-bold mb-4 text-sm">Producto</h3>
              <ul className="space-y-3 text-sm">
                {footerContent.productLinks.map((link) => (
                  <li key={link.label}>
                    <Link href={link.href} className="hover:text-white transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2}>
            <div>
              <h3 className="text-white font-bold mb-4 text-sm">Developers</h3>
              <ul className="space-y-3 text-sm mb-8">
                {footerContent.developerLinks.map((link) => (
                  <li key={link.label}>
                    <Link href={link.href} className="hover:text-white transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
              <h3 className="text-white font-bold mb-4 text-sm">Compañía</h3>
              <ul className="space-y-3 text-sm">
                {footerContent.companyLinks.map((link) => (
                  <li key={link.label}>
                    <Link href={link.href} className="hover:text-white transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3}>
          <div className="border-t border-kobra-border-dark pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p>&copy; {new Date().getFullYear()} Kobra. Todos los derechos reservados.</p>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              className="hover:text-kobra-accent transition-colors"
            >
              Contacto: {CONTACT_PHONE}
            </a>
          </div>
        </FadeIn>
      </SectionContainer>
    </footer>
  );
}
